<template>
    <el-empty :image-size="imgSize"></el-empty>
</template>

<script>
export default {
    props: {
        imgSize: {
            type: Number,
            default: 120,
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/module/noData/index.vue